const WorkshopTypes = {
    dachauer: "Dachauerstr. 125",
    hohenzollern: "Hohenzollernstraße 32"
}

const BikeTypes = {
    rennrad: "Rennrad",
    citybike: "Citybike",
    mtb: "Mountainbike",
    nabe: "Fahrrad mit Nabenschaltung",
};

// Buttons in the first section
btn_dachauer = document.getElementById("workshop-btn-dachauer")
btn_hohenzollern = document.getElementById("workshop-btn-hohenzollern")

// Buttons in second section
select_bike_section = document.getElementById("select-bike-type")
bike_selection_title = document.getElementById("scroll-to-bike-title")
btn_rennrad = document.getElementById("bike-btn-rennrad");
btn_citybike = document.getElementById("bike-btn-citybike");
btn_mountainbike = document.getElementById("bike-btn-mountainbike");
btn_nabe = document.getElementById("bike-btn-nabenschaltung");

// Sections with all the categories
cat_rennrad = document.getElementById("category-rennrad");
cat_citybike = document.getElementById("category-citybike");
cat_mountainbike = document.getElementById("category-mountainbike");
cat_nabenschaltung = document.getElementById("category-nabenschaltung");

// Section with Gesamtübersicht
ubersicht_sec = document.getElementById("ubersicht-section");

// All Checkboxes in Service Table
boxes = document.getElementsByClassName("service-checkbox");

// Add click events to workshop buttons
btn_dachauer.addEventListener("click", () => selectWorkshop(WorkshopTypes.dachauer, btn_dachauer))
btn_hohenzollern.addEventListener("click", () => selectWorkshop(WorkshopTypes.hohenzollern, btn_hohenzollern))

// Add click Events to Bike Buttons
btn_rennrad.addEventListener("click", () => showSelectedService(BikeTypes.rennrad, btn_rennrad));
btn_citybike.addEventListener("click", () => showSelectedService(BikeTypes.citybike, btn_citybike));
btn_mountainbike.addEventListener("click", () =>
    showSelectedService(BikeTypes.mtb, btn_mountainbike)
);
btn_nabe.addEventListener("click", () => showSelectedService(BikeTypes.nabe, btn_nabe));

let workshop_btns = [btn_dachauer, btn_hohenzollern]
let bike_btns = [btn_rennrad, btn_citybike, btn_mountainbike, btn_nabe];

let selectedWorkshopType = null;
let selectedBikeType = null;


// Gets called when a workshop is selected. Give the
function selectWorkshop(type, el) {
    // If the same workshop is clicked do nothing
    if (type == selectedWorkshopType) {
        return;
    }

    selectedWorkshopType = type

    // Re-Color clicked Workshop
    workshop_btns.forEach((btn) => {
        btn.classList.remove("kachel-selected")
    })

    // :focus pseudo-class changes color on click, JS changes it "permanently"
    el.classList.add("kachel-selected");

    select_bike_section.classList.remove("hidden")

    // Scroll to category
    setTimeout(() => {
        bike_selection_title.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 500);
}

/**
 * gets called when a Bike-Type is selected. It will hide all other section but the selected one.
 * It will also reset the clicked services and uncheck all checkmarks. If the same button is clicked
 * nothing will happen.
 */
function showSelectedService(type, el) {
    // If the same bike is clicked do nothing
    if (type == selectedBikeType) {
        return;
    }
    // Else, check which bike is clicked, and show the categories etc.
    selectedBikeType = type;

    /* --------------------------------------------- UI --------------------------------------------- */
    // Re-Color clicked Category
    bike_btns.forEach((btn) => {
        btn.classList.remove("kachel-selected");
    });

    // :focus pseudo-class changes color on click, JS changes it "permanently"
    el.classList.add("kachel-selected");
    /* ---------------------------------------------------------------------------------------------- */

    let categories = [cat_rennrad, cat_citybike, cat_mountainbike, cat_nabenschaltung];
    let currentSection = null;

    // Close all
    categories.forEach((cat) => {
        // cat.style.maxHeight = null;
        cat.classList.add("hidden");
    });

    // Uncheck all checkboxes when switching bikes
    for (let i = 0; i < boxes.length; i++) {
        const box = boxes[i];
        box.checked = false;
    }
    // Reset sum when switching bikes
    sum = 0;
    // Empty Array on switching bikes
    services = [];

    // Reset the price in the Termin-Buchen button
    for (let i = 0; i < totalPriceSpans.length; i++) {
        const span = totalPriceSpans[i];
        span.textContent = "";
    }

    // select which section to show, depending on clicked type
    switch (type) {
        case BikeTypes.rennrad:
            currentSection = cat_rennrad;
            break;
        case BikeTypes.citybike:
            currentSection = cat_citybike;
            break;
        case BikeTypes.mtb:
            currentSection = cat_mountainbike;
            break;
        case BikeTypes.nabe:
            currentSection = cat_nabenschaltung;
            break;
    }

    // Show the relevant category
    currentSection.classList.remove("hidden");

    // Reveal Preis Übersicht only after a category is chosen.
    ubersicht_sec.classList.remove("hidden");

    // Scroll to category
    setTimeout(() => {
        currentSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 500);

    // Empty Table after reset
    updateTable();
}

/* -------------------------------------- Price Calculator -------------------------------------- */

totalPriceSpans = document.getElementsByClassName("total-price");

let services = [];
let sum = 0;

const doMagic = (self, price, task, full_price, checkbox_name) => {

    // Check if Service has been checked or unchecked. 
    //Check or uncheck accordingly the other duplicates (only the case for popular entries which are in the list multiple times)
    if (self.checked) {
        document.getElementsByName(checkbox_name).forEach((e) => {
            e.checked = true
        })
    } else {
        document.getElementsByName(checkbox_name).forEach((e) => {
            e.checked = false
        })
    }

    let addNewValue = true;
    for (let i = 0; i < services.length; i++) {
        current_service = services[i];

        // Remove from service array if checkbox has been clicked again
        if (current_service.task == task) {
            services.splice(i, 1);
            addNewValue = false;
        }
    }

    // Add new entry (as pseudo tuple)
    if (addNewValue) {
        services.push({ task, price, full_price });
    }

    // Calculate Sum
    sum = 0;
    for (let i = 0; i < services.length; i++) {
        current_service = services[i];
        sum += current_service.price;
    }

    // Update Price in Button
    for (let i = 0; i < totalPriceSpans.length; i++) {
        const span = totalPriceSpans[i];
        span.textContent = "(" + sum + "€)";
    }

    updateTable();
};

/* ---------------------------------------------------------------------------------------------- */
/* -------------------------------------- Build HTML Table -------------------------------------- */

let table = document.getElementById("ubersicht-tabelle");

function updateTable() {
    // Remove children (may not be the most efficient way)
    table.innerHTML = "";

    // Create Header (Auftrag/Preis)
    let header = table.createTHead();
    let row = header.insertRow(0);

    let header1 = row.insertCell(0);
    let header2 = row.insertCell(1);

    // Cursed way to detect language, but whatever
    let pathElements = window.location.pathname.split('/');
    if (pathElements.includes("en")) {
        header1.outerHTML = "<th>Service</th>";
        header2.outerHTML = "<th>Price</th>";
    } else {
        header1.outerHTML = "<th>Auftrag</th>";
        header2.outerHTML = "<th>Preis</th>";
    }



    // Insert all other rows
    for (let i = 0; i < services.length; i++) {
        const service = services[i];

        // Create an empty <tr> element and add it to the 1st position of the table:
        let row = table.insertRow();

        // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
        let cell1 = row.insertCell(0);
        let cell2 = row.insertCell(1);

        // Add some text to the new cells:
        cell1.innerHTML = service.task;
        cell2.innerHTML = service.full_price;
    }

    // Last Row with the Sum
    let sumRow = table.insertRow();

    let cell1 = sumRow.insertCell(0);
    let cell2 = sumRow.insertCell(1);

    // Inserted with some extra styling.

    if (pathElements.includes("en")) {
        cell1.outerHTML = '<th style="border-top: 2px solid black; font-weight:bold">Total</th>';
    } else {
        cell1.outerHTML = '<th style="border-top: 2px solid black; font-weight:bold">Gesamt</th>';
    }

    cell2.outerHTML = `<th style="border-top: 2px solid black; font-weight:bold">${sum} €</th>`;
}

/* --------------------------------------- Calendly Stuff --------------------------------------- */

function openCalendly() {
    // Build pretty description
    let message =
        "Werkstatt: " + selectedWorkshopType + "\n" +
        "Fahrrad Typ: " + selectedBikeType + "\n";

    for (let i = 0; i < services.length; i++) {
        const service = services[i];

        let row = "- " + service.task + " (" + service.price + "€)\n";
        message += row;
    }

    if (selectedWorkshopType == WorkshopTypes.dachauer) {
        /**
         * a1 is the first optional field that can be filled.
         */
        Calendly.initPopupWidget({
            url: "https://calendly.com/derrecyclistservice/fahrradannahme",
            prefill: { customAnswers: { a4: message } },
        });
    }

    if (selectedWorkshopType == WorkshopTypes.hohenzollern) {
        /**
         * a1 is the first optional field that can be filled.
         * here the 'Auftrag' is a3, before it is a4. I'm not sure why. Maybe the form was created in a different order or something
         */
        Calendly.initPopupWidget({
            url: "https://calendly.com/infoderrecyclist/hohenzollernstrasse",
            prefill: { customAnswers: { a3: message } },
        });
    }


    return false;
}

// ! Used for Testing
// showSelectedService(BikeTypes.rennrad, btn_rennrad)
